// extracted by mini-css-extract-plugin
module.exports = {"zoomableImage":"ZoomImage_zoomableImage__ckVU4","zoomedImage":"ZoomImage_zoomedImage__GPkvK"};